import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../../common/ui/card';
import { Button } from '../../common/ui/button';
import { Sparkles } from 'lucide-react';
import { useWorkspaceExperience } from '../../hooks/useWorkspaceExperience';

const COPY = {
  business: {
    title: 'Unlock more agents & phone features',
    description: 'Upgrade your plan to add phone numbers, more agents, and higher call volume.',
    cta: 'View plans',
  },
  builder: {
    title: 'Higher API limits',
    description: 'Upgrade for increased external API rate limits and concurrent sessions.',
    cta: 'View plans',
  },
  agency: {
    title: 'Scale client workspaces',
    description: 'Upgrade to manage more client agents and consolidated usage.',
    cta: 'View plans',
  },
  enterprise: {
    title: 'Enterprise capabilities',
    description: 'Contact us for SSO, audit exports, dedicated support, and custom SLAs.',
    cta: 'View plans',
  },
};

export default function UpgradePromptCard({ featureKey, className = '' }) {
  const { workspace } = useWorkspaceExperience();
  const copy = COPY[workspace] || COPY.business;

  return (
    <Card className={`border-amber-200 dark:border-amber-800 bg-amber-50/80 dark:bg-amber-900/20 ${className}`}>
      <CardContent className="p-4 flex flex-col sm:flex-row sm:items-center gap-3 justify-between">
        <div className="flex gap-3">
          <Sparkles className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
          <div>
            <p className="font-medium text-amber-900 dark:text-amber-100">{copy.title}</p>
            <p className="text-sm text-amber-800/80 dark:text-amber-200/80 mt-0.5">
              {featureKey ? `${copy.description}` : copy.description}
            </p>
          </div>
        </div>
        <Button asChild size="sm" variant="outline" className="shrink-0 border-amber-300">
          <Link to="/payment">{copy.cta}</Link>
        </Button>
      </CardContent>
    </Card>
  );
}
